import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const PAGE_TITLE = 'EDUFIS PRONTO™ – Lezioni di Educazione Fisica pronte per Primaria e Secondaria';
const PAGE_DESCRIPTION = 'Il sistema in 6 volumi per docenti di Educazione Fisica e Scienze Motorie: programmazione annuale, 8 UDA, lezioni di sport di squadra, 50 sessioni, 50 giochi, 120+ schede visuali, valutazione e planner, più 5 bonus. PDF digitale, pagamento unico, garanzia 7 giorni.';
function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'it';
    document.title = PAGE_TITLE;
    setMeta('name', 'description', PAGE_DESCRIPTION);
    setMeta('property', 'og:title', PAGE_TITLE);
    setMeta('property', 'og:description', PAGE_DESCRIPTION);
    setMeta('property', 'og:locale', 'it_IT');
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="356rv4texg92">
      <div lang="it" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="38b66v0ldsdg">
        <CountdownBar data-id="element-2" data-mp="3uevui6z9im6s" />
        <main data-id="element-3" data-mp="d4e75xjpjkyt">
          <Hero data-id="element-4" data-mp="d4xp3e9cy9cu" />
          <StatsBar data-id="element-5" data-mp="d3mi75km8lhi" />
          <Difference data-id="element-6" data-mp="d3wch5cp1et0" />
          <Recognize data-id="element-7" data-mp="d2bhxfqdpvv5" />
          <WhatsInside data-id="element-8" data-mp="851kpdwr0fwr" />
          <InsidePages data-id="element-9" data-mp="86mgf6usu4w7" />
          <Bonuses data-id="element-10" data-mp="86cmj86mvdl8" />
          <HowItWorks data-id="element-11" data-mp="83qi3hf1he78" />
          <Audience data-id="element-12" data-mp="3gkv17sr2xrdt" />
          <Offer data-id="element-13" data-mp="3gmfwjkl7xecq" />
          <Guarantee data-id="element-14" data-mp="3glwbvw46obv0" />
          <Testimonials data-id="element-15" data-mp="3gja887keygi2" />
          <Faq data-id="element-16" data-mp="3bmjsxmgfnoxp" />
          <FinalCta data-id="element-17" data-mp="3bn2ys4st6mvd" />
        </main>
        <Footer data-id="element-18" data-mp="3bnus18yxo8ih" />
      </div>
    </MotionConfig>;
}